import axios from 'axios';
import { useMutation } from 'react-query';

import config from '../config';

// apis
const uploadFile = ({ data }) => axios.post(`${config?.AWS.fileUploadUrl}`, data);

// queries

// mutations
export const useFileUploadData = () => useMutation(uploadFile);



// WEBPACK FOOTER //
// ./src/hooks/useFileUploadData.js